// extracted by mini-css-extract-plugin
export default {"userNotificationsContainer":"style_userNotificationsContainer__YfHnF","info":"style_info__jVBi9","body":"style_body__sTpgE"};